import { Money, ProductConditionCode } from "../../common/models/CommonModels";
import { ProductAvailabilityCode } from "../../customer/shared/models/customerBuyerStockItemsModels";
import { FileModel, Page, QueryBase } from "../../shared/models/models";

export interface AdminOffersState {
  query: AdminOffersQuery;
  offers?: Page<AdminOffer>;
  offer?: AdminOffer;
  loading: boolean;
  success?: string;
  error: any;
}

export interface AdminOffer {
  id: string;
  createdDate: Date;
  quotationRequestId: string;
  quotationRequestCreatedDate: string;
  quotationRequestNumber: string;
  supplierId: string;
  stockItemId: string;
  productNumber: string;
  productAlternativeNumber: string;
  availabilityCode: ProductAvailabilityCode;
  productConditionCode: ProductConditionCode;
  description: string;
  unitPrice: Money;
  quantity?: number;
  warrantyPeriodMonths?: number;
  isPriceBoundToDocument: boolean,
  statusCode: OfferStatusCode;
  supplier: CustomerReference;
  buyer: CustomerReference;
  manufacturer: ManufacturerReference;
  category: CategoryReference;
  documentFile: FileModel;
  imageFile: FileModel;
}

export interface ManufacturerReference {
  id: string;
  name: string;
}

export interface CategoryReference {
  id: string;
  name: string;
}

export interface CustomerReference {
  id: string;
  name: string;
  countryId: number;
  countryName: string;
}

export interface AdminOffersQuery extends QueryBase<AdminOffersQueryParameter> {
}

export enum OfferStatusCode {
  new = 1,
  seen = 2,
  accepted = 3,
  declined = 4,
  canceled = 5
}

export enum AdminOffersQueryParameter {
  createdDate = 1,
  modifiedDAte = 2,
  supplierName = 3,
  buyerName = 4,
  productName = 5,
  productNumber = 6,
  quantity = 7,
  price = 8
}

export const isAdminOffersQueryEmpty = (query: AdminOffersQuery): boolean => {
  return !query.search;
};
